import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Link, useParams, useNavigate } from "react-router-dom";
import { 
  Phone, Mail, MapPin, Bed, Bath, Waves, Fish, Flame, Dog, Wifi, Tv, 
  UtensilsCrossed, Anchor, ChevronRight, Menu, X, TreePine, Check,
  ExternalLink, ChevronDown, ChevronLeft
} from "lucide-react";

// Custom Logo
const logoUrl = "https://lh3.googleusercontent.com/d/1sut2Y509003M2dWf5VM0sStYuLQlVYQF";

// Image URLs converted for web display
const img = (id) => `https://lh3.googleusercontent.com/d/${id}`;

// All Images Organized
const images = {
  // Cattails Edge
  cattailsInterior: [
    img("1LiUs4UmAYxGH6P7LhJbyoiF_g4y5V-TN"),
    img("1nopEfZZi0pcQ3Of3HNkEvZQ9V9i1C7gN"),
    img("1nbWsZibzymzEktowUGe92_eAbKf404aB"),
    img("1ocRas6WW95Viy-oOyuFGSPTGNFwIt5W4"),
    img("1n_ccwYjQYvTbpn6bTdLZHq-4B-GgSh-r"),
    img("1OdvPiRHiRSNEi6micF7PTh_TZ4nm6TkW"),
    img("1sD9czN5Y1q2Cr6KcKAucsnn9ZZx0jPil"),
    img("1pjEbgM6eIvoAAPqSue41EDewa1CSm0QR"),
    img("1nyGQJV-GPA72yMQ2GTWML8Av2lSUHon9")
  ],
  cattailsExterior: [
    img("1ozwrGb3Ou5cgDH7O6rsID3zOWTiqxvSb"),
    img("1nYJECnWLIya-esqn9eL8QgsKN_QAJ7so"),
    img("1WOWIDSbqmwNiims9E31WuoVcItN-zClo"),
    img("1Y1Ng564w0aAlUYxAQMaShuO_xX-7pe8G")
  ],
  
  // Willows Edge
  willowsInterior: [
    img("1qt6d4kgcnQBI5NS8egez0XDMdSW-gU-3"),
    img("1r4f483cUrw5RSkpt1hmflnryWlpPH4Rh"),
    img("1r-LFnFgWhWGiDsIA98oJFwqznaltzCyA"),
    img("1r2BZWxYcSGn1uU77fqvP1KnPtvA1hnNx"),
    img("1vbWNHTJgb4gyraD2T011JyXkYUHabeaG"),
    img("1walz0JcF6i2aq7K42bBNNDVY4oGNT4SQ"),
    img("1weUmhbhGGUo2EK16rLf-eRVllRkAQrCy"),
    img("1vb_eoVmjaTu8Jwz70lCnmrFnJxspJDEE")
  ],
  willowsPorch: [
    img("1rMPhcmH_Rk4GDe6AT8P1slUVcnTrADN_"),
    img("1ufSFOECsCpCxEiH5cSbXCXHQDXuHOh34"),
    img("1xiMYw86xtBLMyPcbhXNLGUbtDjuSDsFy"),
    img("1xQNGxkFWO8FpK3uJ6oCwhgirf6E0XSVi")
  ],
  willowsGrounds: [
    img("1w_TxHaUYpuacKMK3vB7bFo8K6uJNgPIx"),
    img("1qz7RNrd1io66rEKmQvKE4n_oqFE7gBtM"),
    img("1vdA7YqJWW36kjGVD4xaJ2RXMNWvcn9Hg"),
    img("1wLl_1gohR0bs06pZJpnk-6dl72FOCcqu"),
    img("1xWLN_YHvqpqLkPjdXEk3dVbbTwGNtvbV"),
    img("1wnE3ORAIz40TDVkDnKhB6gHLQPPX6FEs")
  ],
  willowsShower: [
    img("1r4wEI_TCdxZ-2ASpdEQawzPOx0UVt7mw"),
    img("1rIKlbK6EzP4pBWMLDLuBXWubBXgJwZiB")
  ],
  
  // Waters Edge Paradise
  watersInterior: [
    img("1-0pTpdDNSWYt0hf_P9w01lF3tjm4D-Sn"),
    img("1K57ZdAc5K0_fAjVUDrsCSi6kUlb2INhk"),
    img("1qYdTvX_ON4gddl8YRT2G1n-115nHV6y8"),
    img("1q2OP-Qzb-QHjLDEs2HAMshyLz-PEinJc"),
    img("1q8o_3n3HEHS4fDW8TUtlFf8T7bbiixJD"),
    img("1q8Ocj43RI1UjjHU-QiT-Y7JIbL5OpCTd"),
    img("1qien9bVIxarRMlpgA6Bo8Jsx4WKRQzId"),
    img("1bPI2OLl5jvTjq5n2DJ6PobO3IeKDuXZU"),
    img("1qfQVf2bzit4J5ALOAuNgteZkMhobm0x8")
  ],
  watersExterior: [
    img("1r_dv8PyWsw_QZYCDe3ERi6G7zIXLJ3hY"),
    img("1iU0Mfeo93FAAL21AtRuep9TRen1yy8hS"),
    img("1u7VE1YOwYQ3ebeA1eSzjb2FBui33VUJF"),
    img("1qZl5qS5IOqLEfoC1fEzdXxPrLCsLrtJi"),
    img("1qoRtOEw8z5PdhRanCZsrrS8bQVRgDAp5")
  ],
  
  // Park Areas
  park: [
    img("1o1Z_v7jyulCPtjLAe9vmpFx5Y1kPz50E"),
    img("1o2eiNoRsyt1a7r_ulU47svlSGxsB2rnI"),
    img("1OrRiU36_TW7B_JGJRA1SE97LyFPYKLHW"),
    img("1253ayKKkhdXWOwRvBwGsTVzjBbk8OT0i"),
    img("1yVjuyXEOoYcavmw7hHUUn5NXR3ubUq1N"),
    img("1fgN4Kuo9jCxJZvPOGPFMOdAdZvR-wB9u"),
    img("1BS00wFj2bKmzlj9iStimQ40xfLY-zHwY"),
    img("1YsD3WK_uBe3MTF_ATrHhGevNphQhgwey"),
    img("1rWX0fXO7z0qhZ8tifTE-KgXakwgkuxr8"),
    img("1cY-AZ3kvFx6vxIWnap2lHnAt7PHuVAwQ"),
    img("19ikmhzZMFa8fvB3V9MSyyUGY8fSLK0fp"),
    img("1mOUQcU0coGRtmkFDHqNsI5LO0SckswYl"),
    img("1Eks9TBYeTxSbWssT-xyrTsAOqDcG8OHQ"),
    img("1Loan6dI-Y22YRRnwVvjjpNFZCJKMUiqH")
  ]
};

// Property Data
const properties = {
  "cattails-edge": {
    id: "cattails-edge",
    name: "Cattails Edge Getaway",
    tagline: "100 yards to Beach",
    owner: "Christina",
    phone: "905-928-7963",
    email: null,
    sleeps: "5-6",
    price: "$150/night",
    priceNote: "3 night minimum",
    cleaningFee: "$40",
    deposit: "$200 refundable",
    bookingDeposit: "15% Non-Refundable",
    calendarUrl: "https://calendar.google.com/calendar/embed?src=1cce6ae0209f52c493e37a7925cb3fd85f2a2033b9e70d3627680e4903996131%40group.calendar.google.com&ctz=America%2FToronto",
    allImages: [...images.cattailsInterior, ...images.cattailsExterior],
    galleryCategories: [
      { name: "Interior", images: images.cattailsInterior },
      { name: "Exterior", images: images.cattailsExterior }
    ],
    description: `Looking for the perfect getaway? One that doesn't include a drive thru or near Toronto? This cozy and family-friendly RV, located in the RV community Twin Springs in Burford ON, halfway between Woodstock and Brantford, just 45 Minutes from Hamilton.

Twin Springs Cottage Condo Community is a very low key park. The focus is chill. It has a beautiful large spring fed pond providing a sandy beach, swimming and fishing (Catch & release except carp). This RV is a very short 100m walk to the pond and sandy beach.

The air-conditioned RV has all the comforts you need for a memorable vacation. Could comfortably sleep 4 adults+, thanks to a dinette bed, RV sofa bed, clic clac sofa bed, and a queen-sized bed in the bedroom.`,
    features: [
      "Air Conditioning", "Queen Bed + Multiple Sleeping Options", "Fully Stocked Kitchen",
      "2 Fridges", "Air Fryer & Foreman Grill", "Keurig & French Press",
      "2 TVs with DVD Collection", "Sound System (Indoor/Outdoor)", "3-Piece Bathroom with Skylight",
      "East-facing Deck with Electric Awning", "Fire Ring (First Night Wood Included)",
      "Corn Hole & Outdoor Games", "Child Life Jackets", "Beach Toys", "Basic Fishing Gear"
    ],
    highlights: [
      { icon: Bed, text: "Sleeps 5-6" }, { icon: Bath, text: "Full Bathroom" },
      { icon: Wifi, text: "Sound System" }, { icon: Tv, text: "2 TVs" },
      { icon: UtensilsCrossed, text: "Full Kitchen" }, { icon: Flame, text: "Fire Pit" }
    ],
    rules: [
      "All guests 14+ must read park rules and site-specific rules",
      "Day visitors permitted with 24hr advance notice",
      "Dogs must be on leash at all times - $25/pile deduction for waste left on lot",
      "Watercraft use is at user's risk - minors must wear flotation devices",
      "Departure: Inform owner of time, checkout before 10:30 AM ($10/hr after)",
      "Normal wear damage is overlooked; aggressive damage deducted from deposit",
      "Owner may enter property if circumstances require",
      "No confrontation with other guests - contact owner for issues",
      "One attempt to rectify behavior complaints before eviction without refund",
      "Early departure for non-owner reasons: only security deposit refunded",
      "Awning must be closed before leaving or retiring for the night",
      "Absolutely NO smoking in the trailer",
      "Keep hose/bucket near campfires - only burn wood, paper, cardboard",
      "Linens not supplied - sleeping bags suggested"
    ]
  },
  "willows-edge": {
    id: "willows-edge",
    name: "Willows Edge Getaway",
    tagline: "Waterfront with Private Dock",
    owner: "Mary",
    phone: "226-388-4781",
    email: null,
    sleeps: "4 adults + 2 kids",
    price: "$160/night",
    priceNote: "3 night minimum",
    weeklyRate: "$1100/week (7 nights)",
    cleaningFee: "$40",
    deposit: "$200 Security Deposit",
    bookingDeposit: "15% Non-Refundable",
    specialNote: "No prime month mark-ups. Same great rates all season! (May-Oct)",
    calendarUrl: "https://calendar.google.com/calendar/embed?src=99b5dd007d9feca9b00f254a5d3bf8a7a54ca406847b6ce97670ff2997254d00%40group.calendar.google.com&ctz=America%2FToronto",
    allImages: [...images.willowsGrounds, ...images.willowsPorch, ...images.willowsInterior, ...images.willowsShower],
    galleryCategories: [
      { name: "Grounds", images: images.willowsGrounds },
      { name: "Porch", images: images.willowsPorch },
      { name: "Interior", images: images.willowsInterior },
      { name: "Outdoor Shower", images: images.willowsShower }
    ],
    description: `Discover your own serene, north-facing escape on a secluded spring-fed lake just west of Brantford! This beautifully updated RV cottage, nestled mere steps from the water's edge, boasts a spacious and inviting living porch, making it a dream retreat for nature lovers and those in search of tranquility.

Perfect for families, it offers a safe, kid-friendly space complete with a sandy beach and a playground for endless fun. Unwind and relish mesmerizing sunsets from your lakeside porch or the cozy dock swing—glass of wine in hand, if you like!

Fire up the large BBQ for al fresco meals, and as the evening sets in, gather around the fire pit for s'mores and stories (first night's firewood is on the house!). Dive into aquatic adventures with the provided paddleboard and two kayaks.`,
    features: [
      "North-facing Waterfront", "Private Dock with Swing", "Living Porch",
      "Fully Equipped Kitchen", "Large BBQ", "Fire Pit (First Night Wood Included)",
      "Paddleboard Included", "2 Kayaks Included", "Outdoor Shower",
      "Sandy Beach Access", "Playground Nearby", "Pet Friendly"
    ],
    highlights: [
      { icon: Bed, text: "Sleeps 6" }, { icon: Bath, text: "1 Bath + Outdoor Shower" },
      { icon: Anchor, text: "Private Dock" }, { icon: Waves, text: "Waterfront" },
      { icon: Dog, text: "Pet Friendly" }, { icon: Flame, text: "Fire Pit" }
    ],
    rules: []
  },
  "waters-edge": {
    id: "waters-edge",
    name: "Waters Edge Paradise",
    tagline: "Waterfront with Large Private Dock",
    owner: "Ravi",
    phone: "416-659-7284",
    email: "ravipersad1@gmail.com",
    sleeps: "5",
    price: "$200/night",
    priceNote: "2 night minimum, 3 on long weekends",
    cleaningFee: "$50",
    deposit: "$200 refundable",
    bookingDeposit: "Contact",
    calendarUrl: null,
    allImages: [...images.watersInterior, ...images.watersExterior],
    galleryCategories: [
      { name: "Interior", images: images.watersInterior },
      { name: "Exterior", images: images.watersExterior }
    ],
    description: `Escape to your own very clean south facing oasis on a spring fed Private lake just west of Brantford! This charming renovated RV cottage is 6 feet from the water, with a large add-on room and is perfect for nature lovers and those seeking a serene retreat.

Kid friendly including a sand beach and playground. Enjoy breathtaking sunsets under your covered lakeside gazebo and on your beautiful 12x12 dock just steps away.

Inside, the cottage comfortably sleeps 5 guests with one queen bed, one single futon and one double futon. You will find a fully stocked kitchen for all your cooking needs. Outside, there is a 5 burner BBQ for grilling enthusiasts and a cozy fire pit for evening relaxation.`,
    features: [
      "South-facing Waterfront", "6 Feet from Water", "Brand New 12x12 Private Dock",
      "Covered Lakeside Gazebo", "Queen Bed + Futons", "Fully Stocked Kitchen",
      "5 Burner BBQ", "Fire Pit (First Night Wood Included)", "5 Person Paddle Boat",
      "Paddleboard", "Kayak", "A/C & Central Heating", "Unlimited WiFi",
      "Big Screen TV", "Open Concept Florida Room", "Large Covered Deck",
      "On-site Laundry", "Board Games & Corn Hole", "Pet Free Environment"
    ],
    highlights: [
      { icon: Bed, text: "Sleeps 5" }, { icon: Bath, text: "4-Piece Bath" },
      { icon: Anchor, text: "12x12 Dock" }, { icon: Waves, text: "6ft from Water" },
      { icon: Wifi, text: "Unlimited WiFi" }, { icon: Tv, text: "Big Screen TV" }
    ],
    rules: []
  }
};

// Park Rules
const parkRules = [
  "Quiet time is between 11:00 PM and 7:00 AM. Fires and considerate quiet conversation permitted after 11:00 PM.",
  "Dogs MUST be on a leash at ALL times. No dogs on beach. Excessive barking not tolerated.",
  "Campfires: No accelerants. Must be under control with adult nearby. Extinguish after use.",
  "Speed limit is 10 KM/HR - strongly enforced. Children running and riding about.",
  "No tents permitted unless previous permission obtained.",
  "NOTHING flushed besides human waste and toilet paper.",
  "Off-lot beverages must NOT be in glass containers.",
  "Fireworks are not permitted ever! Park has display for Canada & Victoria Days.",
  "Children under 12 MUST be accompanied by adult on beach and all park areas.",
  "Swimming and boating not permitted after dark.",
  "Inappropriate language frowned upon. Please be aware of little ears.",
  "Lifejackets must be worn in boats by children under 12.",
  "Do not venture onto private property unless invited. No shortcuts.",
  "Boats must be docked securely when not in use.",
  "Do not negatively affect enjoyment of other campers.",
  "Park vehicles ONLY where instructed."
];

// Local Activities
const localActivities = [
  { name: "County of Brant Activities", url: "https://www.brant.ca/en/arts-culture-events/visit-and-discover-brant.aspx" },
  { name: "Paris, ON - Prettiest Town in Canada", url: "https://stephaniegalt.com/the-best-things-to-do-in-paris-ontario/" },
  { name: "Paris Trip Advisor", url: "https://www.tripadvisor.ca/Attractions-g155006-Activities-a_allAttractions.true-Paris_Ontario.html" },
  { name: "Brantford Activities", url: "https://www.tripadvisor.ca/Attractions-g154983-Activities-a_allAttractions.true-Brantford_Ontario.html" },
  { name: "Woodstock Activities", url: "https://www.tripadvisor.ca/Attractions-g262783-Activities-a_allAttractions.true-Woodstock_Ontario.html" },
  { name: "Golf Courses Nearby", url: "https://www.google.com/maps/search/golf+courses+near+burford+ontario" }
];

// Navigation Component
const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 glass-effect shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16 md:h-20">
            <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
              <img src={logoUrl} alt="Spring Side Getaways" className="w-10 h-10 rounded-lg object-cover" />
              <span className="font-['Playfair_Display'] text-xl md:text-2xl font-semibold text-[#2D5016]">
                Spring Side Getaways
              </span>
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className="nav-link font-medium">Home</Link>
              <Link to="/properties" className="nav-link font-medium">Properties</Link>
              <Link to="/park-info" className="nav-link font-medium">Park Info</Link>
              <Link to="/activities" className="nav-link font-medium">Activities</Link>
              <Link to="/contact" className="btn-primary" data-testid="nav-contact-btn">Contact Us</Link>
            </div>
            <button className="md:hidden p-2" onClick={() => setIsOpen(true)} data-testid="mobile-menu-btn">
              <Menu className="w-6 h-6 text-[#2D5016]" />
            </button>
          </div>
        </div>
      </nav>
      <div className={`mobile-menu-overlay ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(false)} />
      <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        <div className="p-6">
          <div className="flex justify-between items-center mb-8">
            <span className="font-['Playfair_Display'] text-xl font-semibold text-[#2D5016]">Menu</span>
            <button onClick={() => setIsOpen(false)} data-testid="mobile-menu-close"><X className="w-6 h-6" /></button>
          </div>
          <div className="flex flex-col gap-4">
            <Link to="/" className="text-lg py-2 border-b border-gray-100" onClick={() => setIsOpen(false)}>Home</Link>
            <Link to="/properties" className="text-lg py-2 border-b border-gray-100" onClick={() => setIsOpen(false)}>Properties</Link>
            <Link to="/park-info" className="text-lg py-2 border-b border-gray-100" onClick={() => setIsOpen(false)}>Park Info</Link>
            <Link to="/activities" className="text-lg py-2 border-b border-gray-100" onClick={() => setIsOpen(false)}>Activities</Link>
            <Link to="/contact" className="btn-primary text-center mt-4" onClick={() => setIsOpen(false)}>Contact Us</Link>
          </div>
        </div>
      </div>
    </>
  );
};

// Footer
const Footer = () => (
  <footer className="bg-[#2D5016] text-white py-16">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <img src={logoUrl} alt="Logo" className="w-10 h-10 rounded-lg object-cover" />
            <span className="font-['Playfair_Display'] text-2xl font-semibold">Spring Side Getaways</span>
          </div>
          <p className="text-white/80 mb-4">Your perfect vacation escape at Twin Springs Cottage Condo Community in Burford, Ontario.</p>
          <div className="flex items-center gap-2 text-white/80">
            <MapPin className="w-5 h-5" /><span>99 Fourth Concession Rd, Burford, ON</span>
          </div>
        </div>
        <div>
          <h4 className="font-['Playfair_Display'] text-xl font-semibold mb-4">Our Properties</h4>
          <div className="flex flex-col gap-3">
            <Link to="/property/cattails-edge" className="text-white/80 hover:text-white transition-colors">Cattails Edge - Christina @ 905-928-7963</Link>
            <Link to="/property/willows-edge" className="text-white/80 hover:text-white transition-colors">Willows Edge - Mary @ 226-388-4781</Link>
            <Link to="/property/waters-edge" className="text-white/80 hover:text-white transition-colors">Waters Edge - Ravi @ 416-659-7284</Link>
          </div>
        </div>
        <div>
          <h4 className="font-['Playfair_Display'] text-xl font-semibold mb-4">Quick Links</h4>
          <div className="flex flex-col gap-3">
            <Link to="/park-info" className="text-white/80 hover:text-white transition-colors">Park Rules & Info</Link>
            <Link to="/activities" className="text-white/80 hover:text-white transition-colors">Local Activities</Link>
            <a href="https://booee.com/kozmik/99-concession-rd-4-brant-on-n0e-1a0-can-1" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors flex items-center gap-1">
              Digital Guide <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/20 mt-12 pt-8 text-center text-white/60">
        <p>© {new Date().getFullYear()} Spring Side Getaways. All rights reserved.</p>
        <p className="mt-2 text-sm">No drive thru Toronto to dread - it's already a great vacation!</p>
      </div>
    </div>
  </footer>
);

// Property Card
const PropertyCard = ({ property, index }) => (
  <Link to={`/property/${property.id}`} className="property-card block bg-white rounded-2xl overflow-hidden shadow-lg animate-fade-in-up" style={{ animationDelay: `${index * 0.1}s` }} data-testid={`property-card-${property.id}`}>
    <div className="relative h-64 overflow-hidden">
      <img src={property.allImages[0]} alt={property.name} className="w-full h-full object-cover" />
      <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
        <span className="text-[#2D5016] font-semibold">{property.price}</span>
      </div>
    </div>
    <div className="p-6">
      <h3 className="font-['Playfair_Display'] text-2xl font-semibold text-[#2D5016] mb-2">{property.name}</h3>
      <p className="text-[#7A9E6B] font-medium mb-4">{property.tagline}</p>
      <div className="flex flex-wrap gap-3 mb-4">
        {property.highlights.slice(0, 4).map((h, i) => (
          <div key={i} className="flex items-center gap-1 text-sm text-gray-600">
            <h.icon className="w-4 h-4 text-[#7A9E6B]" /><span>{h.text}</span>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between pt-4 border-t border-gray-100">
        <div className="flex items-center gap-2 text-gray-600">
          <Phone className="w-4 h-4" /><span>{property.owner} @ {property.phone}</span>
        </div>
        <ChevronRight className="w-5 h-5 text-[#2D5016]" />
      </div>
    </div>
  </Link>
);

// Home Page
const HomePage = () => (
  <div className="min-h-screen">
    <section className="relative h-screen min-h-[600px]" data-testid="hero-section">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url('${images.park[1]}')` }} />
      <div className="absolute inset-0 hero-gradient" />
      <div className="relative h-full flex flex-col items-center justify-center text-center px-4 pt-20">
        <h1 className="font-['Playfair_Display'] text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 animate-fade-in-up">
          Welcome to<br />Spring Side Getaways
        </h1>
        <p className="text-xl md:text-2xl text-white/90 max-w-2xl mb-8 animate-fade-in-up animation-delay-200">
          Your perfect vacation escape at Twin Springs in Burford, Ontario.<br />No drive thru Toronto to dread!
        </p>
        <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up animation-delay-300">
          <Link to="/properties" className="btn-primary text-lg px-8 py-4" data-testid="hero-explore-btn">Explore Properties</Link>
          <Link to="/contact" className="btn-secondary bg-white/10 text-white border-white hover:bg-white hover:text-[#2D5016] text-lg px-8 py-4">Contact Us</Link>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown className="w-8 h-8 text-white/80" />
      </div>
    </section>
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Map Section */}
        <div className="mb-8 rounded-2xl overflow-hidden shadow-lg">
          <iframe 
            src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=99+Fourth+Concession+Rd,Burford,ON,Canada&zoom=11"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Location Map - Midway between Brantford and Woodstock"
            className="w-full"
          />
        </div>
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <MapPin className="w-6 h-6 text-[#2D5016]" />
            <span className="text-lg text-gray-600">99 Fourth Concession Rd, Burford, ON N0E 1A0</span>
          </div>
          <p className="text-gray-600">Twin Springs Cottage Condo Community • Midway between Brantford and Woodstock • 45 min from Hamilton</p>
        </div>
      </div>
    </section>
    <section className="py-20 px-4" data-testid="properties-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-[#2D5016] mb-4">Our Getaway Properties</h2>
          <div className="section-divider mb-6" />
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">Three individually owned, unique but equally wonderful accommodations. Discover your next vacation location—one is sure to be perfect for you.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {Object.values(properties).map((p, i) => <PropertyCard key={p.id} property={p} index={i} />)}
        </div>
      </div>
    </section>
    <section className="py-20 bg-[#2D5016] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="font-['Playfair_Display'] text-4xl font-bold mb-6">About Twin Springs</h2>
            <p className="text-white/90 text-lg mb-6">Twin Springs Cottage Condo Community is a very low key park where the focus is chill. It features a beautiful large spring-fed pond with a sandy beach, swimming, and fishing (catch & release, except carp).</p>
            <div className="grid grid-cols-2 gap-4">
              {[{ icon: Waves, text: "Spring-fed Pond" }, { icon: Fish, text: "Fishing" }, { icon: TreePine, text: "Sandy Beach" }, { icon: Dog, text: "Dog Run" }].map((item, i) => (
                <div key={i} className="flex items-center gap-3 text-white/80"><item.icon className="w-5 h-5" /><span>{item.text}</span></div>
              ))}
            </div>
          </div>
          <div className="relative">
            <img src={images.park[0]} alt="Twin Springs Lake" className="rounded-2xl shadow-2xl" />
            <div className="absolute -bottom-6 -left-6 bg-white text-[#2D5016] p-6 rounded-xl shadow-lg">
              <p className="font-['Playfair_Display'] text-2xl font-bold">Family Fun</p>
              <p className="text-gray-600">Peaceful getaway</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="py-12 bg-[#FBF8F3]">
      <div className="max-w-7xl mx-auto px-4">
        <h3 className="font-['Playfair_Display'] text-2xl font-bold text-[#2D5016] text-center mb-8">Park Gallery</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {images.park.map((img, i) => (
            <div key={i} className="aspect-square rounded-lg overflow-hidden">
              <img src={img} alt={`Park view ${i+1}`} className="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
    <section className="py-20 px-4 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-['Playfair_Display'] text-4xl font-bold text-[#2D5016] mb-6">Ready for Your Perfect Getaway?</h2>
        <p className="text-xl text-gray-600 mb-8">Call any of our hosts today to reserve your 2026 vacation.</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/properties" className="btn-primary text-lg">View All Properties</Link>
          <Link to="/contact" className="btn-secondary text-lg">Contact Us</Link>
        </div>
      </div>
    </section>
  </div>
);

// Properties List
const PropertiesPage = () => (
  <div className="min-h-screen pt-24 pb-16 px-4">
    <div className="max-w-7xl mx-auto">
      <div className="text-center mb-16">
        <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-[#2D5016] mb-4">Our Vacation Properties</h1>
        <div className="section-divider mb-6" />
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">Each property is individually owned with its own unique character. Contact the owner directly for availability and booking.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {Object.values(properties).map((p, i) => <PropertyCard key={p.id} property={p} index={i} />)}
      </div>
    </div>
  </div>
);

// Property Page with Gallery
const PropertyPage = () => {
  const { propertyId } = useParams();
  const navigate = useNavigate();
  const property = properties[propertyId];
  const [selectedImage, setSelectedImage] = useState(0);
  const [activeCategory, setActiveCategory] = useState(0);

  if (!property) {
    return (
      <div className="min-h-screen pt-24 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-800 mb-4">Property not found</h1>
          <button onClick={() => navigate('/properties')} className="btn-primary">View All Properties</button>
        </div>
      </div>
    );
  }

  const currentImages = property.galleryCategories[activeCategory]?.images || property.allImages;

  return (
    <div className="min-h-screen pt-20">
      <div className="relative h-[50vh] min-h-[400px]">
        <img src={currentImages[selectedImage]} alt={property.name} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-8">
          <div className="max-w-7xl mx-auto">
            <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-white mb-2">{property.name}</h1>
            <p className="text-xl text-white/90">{property.tagline}</p>
          </div>
        </div>
        {currentImages.length > 1 && (
          <>
            <button onClick={() => setSelectedImage(i => i > 0 ? i - 1 : currentImages.length - 1)} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-full hover:bg-white">
              <ChevronLeft className="w-6 h-6" />
            </button>
            <button onClick={() => setSelectedImage(i => i < currentImages.length - 1 ? i + 1 : 0)} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-full hover:bg-white">
              <ChevronRight className="w-6 h-6" />
            </button>
          </>
        )}
      </div>

      {/* Category Tabs & Thumbnails */}
      <div className="bg-white py-4 border-b">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex gap-4 mb-4 overflow-x-auto">
            {property.galleryCategories.map((cat, i) => (
              <button key={i} onClick={() => { setActiveCategory(i); setSelectedImage(0); }}
                className={`px-4 py-2 rounded-full whitespace-nowrap transition-all ${activeCategory === i ? 'bg-[#2D5016] text-white' : 'bg-gray-100 hover:bg-gray-200'}`}>
                {cat.name} ({cat.images.length})
              </button>
            ))}
          </div>
          <div className="flex gap-2 overflow-x-auto pb-2">
            {currentImages.map((img, i) => (
              <button key={i} onClick={() => setSelectedImage(i)}
                className={`flex-shrink-0 w-20 h-14 rounded-lg overflow-hidden border-2 transition-all ${selectedImage === i ? 'border-[#2D5016]' : 'border-transparent opacity-60 hover:opacity-100'}`}>
                <img src={img} alt={`View ${i+1}`} className="w-full h-full object-cover" />
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div className="lg:col-span-2">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-12">
              {property.highlights.map((h, i) => (
                <div key={i} className="bg-white p-4 rounded-xl shadow-md flex items-center gap-3">
                  <div className="amenity-icon"><h.icon className="w-5 h-5" /></div>
                  <span className="font-medium text-gray-700">{h.text}</span>
                </div>
              ))}
            </div>
            <div className="mb-12">
              <h2 className="font-['Playfair_Display'] text-3xl font-bold text-[#2D5016] mb-6">About This Property</h2>
              <div className="prose prose-lg max-w-none text-gray-600">
                {property.description.split('\n\n').map((p, i) => <p key={i} className="mb-4">{p}</p>)}
              </div>
            </div>
            <div className="mb-12">
              <h2 className="font-['Playfair_Display'] text-3xl font-bold text-[#2D5016] mb-6">Amenities & Features</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {property.features.map((f, i) => (
                  <div key={i} className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm">
                    <Check className="w-5 h-5 text-[#7A9E6B]" /><span className="text-gray-700">{f}</span>
                  </div>
                ))}
              </div>
            </div>
            {property.calendarUrl && (
              <div className="mb-12">
                <h2 className="font-['Playfair_Display'] text-3xl font-bold text-[#2D5016] mb-6">Check Availability</h2>
                <p className="text-gray-600 mb-4">The calendar is to check availability only. Sorry we don't have online booking.</p>
                <div className="calendar-container bg-white">
                  <iframe src={property.calendarUrl} title="Availability Calendar" className="w-full h-[400px] border-0" />
                </div>
              </div>
            )}
            {property.rules.length > 0 && (
              <div>
                <h2 className="font-['Playfair_Display'] text-3xl font-bold text-[#2D5016] mb-6">Rules & Expectations</h2>
                <div className="space-y-3">
                  {property.rules.map((rule, i) => (
                    <div key={i} className="rule-item"><span className="rule-number">{i + 1}</span><p className="text-gray-700">{rule}</p></div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="lg:col-span-1">
            <div className="sticky top-24">
              <div className="bg-white rounded-2xl shadow-xl p-6 mb-6">
                <div className="text-center mb-6">
                  <p className="text-4xl font-bold text-[#2D5016]">{property.price}</p>
                  <p className="text-gray-600">{property.priceNote}</p>
                  {property.weeklyRate && <p className="text-lg font-semibold text-[#7A9E6B] mt-2">{property.weeklyRate}</p>}
                </div>
                <div className="space-y-4 mb-6">
                  <div className="flex justify-between py-2 border-b border-gray-100"><span className="text-gray-600">Cleaning Fee</span><span className="font-medium">{property.cleaningFee}</span></div>
                  <div className="flex justify-between py-2 border-b border-gray-100"><span className="text-gray-600">Security Deposit</span><span className="font-medium">{property.deposit}</span></div>
                  <div className="flex justify-between py-2"><span className="text-gray-600">Booking Deposit</span><span className="font-medium">{property.bookingDeposit}</span></div>
                </div>
                {property.specialNote ? (
                  <div className="text-center text-sm text-[#2D5016] font-medium bg-[#FBF8F3] p-3 rounded-lg mb-6">{property.specialNote}</div>
                ) : (
                  <div className="text-center text-sm text-gray-500 mb-6">Same amazing low rate ALL season.<br />NO prime months markup!</div>
                )}
              </div>
              <div className="contact-card">
                <h3 className="font-['Playfair_Display'] text-xl font-semibold mb-4">Contact {property.owner}</h3>
                <div className="space-y-3">
                  <a href={`tel:${property.phone}`} className="flex items-center gap-3 text-white/90 hover:text-white transition-colors">
                    <Phone className="w-5 h-5" /><span>{property.phone}</span>
                  </a>
                  {property.email && (
                    <a href={`mailto:${property.email}`} className="flex items-center gap-3 text-white/90 hover:text-white transition-colors">
                      <Mail className="w-5 h-5" /><span>{property.email}</span>
                    </a>
                  )}
                </div>
                <a href={`tel:${property.phone}`} className="block w-full mt-6 py-3 bg-white text-[#2D5016] text-center font-semibold rounded-full hover:bg-gray-100 transition-colors">
                  Call to Book Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Park Info Page
const ParkInfoPage = () => (
  <div className="min-h-screen pt-24 pb-16 px-4">
    <div className="max-w-4xl mx-auto">
      <div className="text-center mb-16">
        <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-[#2D5016] mb-4">Park Rules & Information</h1>
        <div className="section-divider mb-6" />
        <p className="text-xl text-gray-600">Twin Springs Cottage Condo Community</p>
      </div>
      <div className="bg-white rounded-2xl shadow-lg p-8 mb-12">
        <h2 className="font-['Playfair_Display'] text-2xl font-bold text-[#2D5016] mb-4">About the Park</h2>
        <p className="text-gray-600 mb-4">The park is owned by J & C Weaver, who are in the ongoing process of upgrading and improving the park. There is now a year-round section of approximately 200+ park model trailers and small homes, as well as the seasonal section that's been around for many years.</p>
        <p className="text-gray-600 mb-4">Swimming and fishing in the spring-fed ponds. No motorized watercraft (trolling motors excepted). Fishing is catch and release, except for carp. NO fishing on the beach - there are public docks available.</p>
        <p className="text-gray-600">Summers are filled with all kinds of fun family events: karaoke nights, pancake breakfasts, ice cream treats, kids' crafts, adult dances, fishing derby for kids, and fireworks for Canada Day and Labour Day!</p>
      </div>
      <div className="bg-[#2D5016] text-white rounded-2xl p-8 mb-12">
        <h2 className="font-['Playfair_Display'] text-2xl font-bold mb-6">Park Amenities</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {["Spring-fed Pond", "Sandy Beach", "Fishing (Catch & Release)", "Leash-free Dog Run", "Laundry Room", "Ice Available at Office", "Firewood Nearby", "Playground", "Pavilion"].map((a, i) => (
            <div key={i} className="flex items-center gap-2"><Check className="w-5 h-5 text-[#7A9E6B]" /><span>{a}</span></div>
          ))}
        </div>
      </div>
      <div>
        <h2 className="font-['Playfair_Display'] text-2xl font-bold text-[#2D5016] mb-6">Park Rules</h2>
        <div className="space-y-3">
          {parkRules.map((rule, i) => (
            <div key={i} className="rule-item"><span className="rule-number">{i + 1}</span><p className="text-gray-700">{rule}</p></div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

// Activities Page
const ActivitiesPage = () => (
  <div className="min-h-screen pt-24 pb-16 px-4">
    <div className="max-w-4xl mx-auto">
      <div className="text-center mb-16">
        <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-[#2D5016] mb-4">Local Activities & Attractions</h1>
        <div className="section-divider mb-6" />
        <p className="text-xl text-gray-600">Discover what's waiting for you in Brant County</p>
      </div>
      <div className="bg-[#2D5016] text-white rounded-2xl p-8 mb-12 text-center">
        <h2 className="font-['Playfair_Display'] text-2xl font-bold mb-4">Your Digital Guide</h2>
        <p className="text-white/80 mb-6">Scan the code or use the link for your personalized digital guide!</p>
        <a href="https://booee.com/kozmik/99-concession-rd-4-brant-on-n0e-1a0-can-1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white text-[#2D5016] px-6 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors">
          Open Digital Guide <ExternalLink className="w-5 h-5" />
        </a>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
        {localActivities.map((a, i) => (
          <a key={i} href={a.url} target="_blank" rel="noopener noreferrer" className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all hover:-translate-y-1 flex items-center justify-between group">
            <span className="font-medium text-gray-700 group-hover:text-[#2D5016]">{a.name}</span>
            <ExternalLink className="w-5 h-5 text-[#7A9E6B]" />
          </a>
        ))}
      </div>
      <div className="bg-[#FBF8F3] rounded-2xl p-8">
        <h2 className="font-['Playfair_Display'] text-2xl font-bold text-[#2D5016] mb-6">What's Nearby</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div><h3 className="font-semibold text-[#2D5016] mb-2">Burford (5 min)</h3><p className="text-gray-600">Post office, pharmacy, Home Hardware, Foodland, banks, 4+ eateries, ice cream!</p></div>
          <div><h3 className="font-semibold text-[#2D5016] mb-2">Even Closer</h3><p className="text-gray-600">Convenience store and mini LCBO/beer store just minutes away.</p></div>
          <div><h3 className="font-semibold text-[#2D5016] mb-2">30 Min Drive</h3><p className="text-gray-600">Golf courses, firing range, 5-floor antique market, museums!</p></div>
          <div><h3 className="font-semibold text-[#2D5016] mb-2">Paris, ON</h3><p className="text-gray-600">Voted the prettiest little town in Canada!</p></div>
        </div>
      </div>
    </div>
  </div>
);

// Contact Page
const ContactPage = () => (
  <div className="min-h-screen pt-24 pb-16 px-4">
    <div className="max-w-4xl mx-auto">
      <div className="text-center mb-16">
        <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-[#2D5016] mb-4">Contact Us</h1>
        <div className="section-divider mb-6" />
        <p className="text-xl text-gray-600">Call any of our helpful hosts to reserve your 2026 vacation</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
        {Object.values(properties).map((p) => (
          <div key={p.id} className="contact-card">
            <h3 className="font-['Playfair_Display'] text-xl font-semibold mb-2">{p.name}</h3>
            <p className="text-white/80 mb-4">{p.tagline}</p>
            <div className="space-y-3">
              <p className="font-semibold">{p.owner}</p>
              <a href={`tel:${p.phone}`} className="flex items-center gap-2 text-white/90 hover:text-white"><Phone className="w-4 h-4" />{p.phone}</a>
              {p.email && <a href={`mailto:${p.email}`} className="flex items-center gap-2 text-white/90 hover:text-white"><Mail className="w-4 h-4" />{p.email}</a>}
            </div>
            <Link to={`/property/${p.id}`} className="block w-full mt-4 py-2 bg-white/20 text-center rounded-full hover:bg-white/30 transition-colors">View Property</Link>
          </div>
        ))}
      </div>
      <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
        <h2 className="font-['Playfair_Display'] text-2xl font-bold text-[#2D5016] mb-4">Our Location</h2>
        <div className="flex items-center justify-center gap-3 mb-4">
          <MapPin className="w-6 h-6 text-[#2D5016]" /><span className="text-lg">99 Fourth Concession Rd, Burford, ON N0E 1A0</span>
        </div>
        <p className="text-gray-600 mb-6">Twin Springs Cottage Condo Community & Camping<br />Midway between Brantford and Woodstock • 45 min from Hamilton</p>
        <a href="https://www.google.com/maps/search/?api=1&query=99+Fourth+Concession+Rd+Burford+ON" target="_blank" rel="noopener noreferrer" className="btn-primary inline-flex items-center gap-2">
          Get Directions <ExternalLink className="w-4 h-4" />
        </a>
      </div>
    </div>
  </div>
);

// App
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/properties" element={<PropertiesPage />} />
          <Route path="/property/:propertyId" element={<PropertyPage />} />
          <Route path="/park-info" element={<ParkInfoPage />} />
          <Route path="/activities" element={<ActivitiesPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
